module.exports = __webpack_public_path__ + "static/2front-positions-1-7ef352f996fce52bc381bc1414c719ea.png";